import {types} from '../../types';

const setGetReplenishmentReportAction = (payload) => {
    return {
        type: types.replenishment.SET_REPLENISHMENT_REPORT_MOBILE,
        payload,
      }
}

const setGetReplenishmentAction = (payload) => {
  return {
      type: types.replenishment.SET_REPLENISHMENT_MOBILE,
      payload,
    }
}

const setGetShiftAction = (payload) => {
  return {
      type: types.replenishment.SET_SHIFT_MOBILE,
      payload,
    }
}

export {
  setGetReplenishmentReportAction as SetGetReplenishmentReportAction,
  setGetReplenishmentAction as SetGetReplenishmentAction,
  setGetShiftAction as SetGetShiftAction
}
